import * as React from 'react'

import { Badge, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  title: string
  active?: boolean
}

const WorkableDay = ({ title, active = false }: Props) => {
  return (
    <Badge size="s24" color={active ? 'viridian1000' : 'viridian100'}>
      <Text size="100" weight="normal" color={active ? 'grey000White' : 'grey800'}>
        {title}
      </Text>
    </Badge>
  )
}

export default observer(WorkableDay)
